type Env =
  | 'localhost'
  | 'localdev'
  | 'development'
  | 'staging'
  | 'production'
  | 'cypress'
  | 'remote';
/**
 * Get the current environment
 */
export const getEnv = (): Env => {
  // Running in Docker mode
  if (window.RUNTIME_ENV === 'production') return 'production';
  if (window.RUNTIME_ENV === 'staging') return 'staging';
  if (window.RUNTIME_ENV === 'development') return 'development';
  if (window.RUNTIME_ENV === 'localhost') return 'localhost';

  //Running in Aspire/Legacy modes
  if (import.meta.env.MODE === 'remote') return 'remote';
  if (import.meta.env.MODE === 'localdev') return 'localdev';
  if (import.meta.env.MODE === 'cypress') return 'cypress';
  if (
    window.location.hostname.includes('localhost') ||
    window.location.hostname.includes('127.0.0.1')
  )
    return 'localhost';
  if (window.location.hostname.includes('development')) return 'development';
  if (window.location.hostname.includes('staging')) return 'staging';
  return 'production';
};

export const uuidv4 = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getTokenData = (userToken: string | null) => {
  if (!userToken) return null;
  return JSON.parse(atob(userToken.split('.')[1]));
};

export const contrastingColour = (hex: string): string => {
  let passedWithHash = false;

  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
    passedWithHash = true;
  }

  let prefix = passedWithHash ? '#' : '';

  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  if (hex.length !== 6) {
    throw new Error('Invalid HEX Colour');
  }

  let red = parseInt(hex.slice(0, 2), 16);
  let green = parseInt(hex.slice(2, 4), 16);
  let blue = parseInt(hex.slice(4, 6), 16);

  return red * 0.299 + green * 0.587 + blue * 0.114 > 186 ? `${prefix}000000` : `${prefix}FFFFFF`;
};

export const isExternalUrl = (raw: string): boolean => {
  return typeof raw === 'string' && raw.startsWith('http');
};

export const isInString = (stack: string, needle: string, caseSensitive?: boolean) => {
  if (caseSensitive) {
    return stack.includes(needle);
  }
  return stack.search(new RegExp(needle, 'i')) !== -1;
};

//TODO: Update this to work with Service Discovery
export const getApiDomain = () => {
  // Check if window.RUNTIME_API_URL is set, return that if present else check env
  if (window.RUNTIME_API_URL) {
    return window.RUNTIME_API_URL;
  }

  switch (getEnv()) {
    case 'cypress':
      return 'https://interface-dev.liftshare.com';
    case 'localdev':
    case 'localhost':
      return import.meta.env.VITE_API_URL;
    case 'development':
    case 'remote':
      return 'https://api.development.mobilityways.dev';
    case 'staging':
      return 'https://interface-staging.liftshare.com';
    case 'production':
    default:
      return 'https://interface.liftshare.com';
  }
};

export const getCdnUrl = () => {
  // Check if window.RUNTIME_API_URL is set, return that if present else check env
  if (window.RUNTIME_CDN_URL) {
    return window.RUNTIME_CDN_URL;
  }

  switch (getEnv()) {
    case 'staging':
    case 'production':
      return 'https://cdn.liftshare.com/';
    default:
      return 'http://localhost:10000/devstoreaccount1/';
  }
};

//TODO: Update this to work with Service Discovery
export const getLiftshareDomain = () => {
  // Check if window.RUNTIME_API_URL is set, return that if present else check env
  if (window.RUNTIME_WEB_URL) {
    return window.RUNTIME_WEB_URL;
  }

  switch (getEnv()) {
    case 'cypress':
      return 'development.liftshare.com';
    case 'localdev':
    case 'localhost':
      return import.meta.env.VITE_WEB_URL;
    case 'development':
    case 'remote':
      return 'https://liftshare.development.mobilityways.dev';
    case 'staging':
      return 'https://staging.liftshare.com';
    case 'production':
    default:
      return 'https://liftshare.com';
  }
};

export const includeOnArray = (condition: any, val: any) => (condition ? [val] : []);

export const getPercentageOf = (comparing: number, compareTo: number) => {
  if (comparing === 0 && compareTo === 0) {
    return 100;
  }
  return (comparing / compareTo) * 100;
};
export const limitNumber = (num: number, limit: number) => (num < limit ? num : limit);

export const getAspectRatio = (width: number, height: number) => height / width;

export const milesToMeters = (val: number) => val * 1609;
export const metersToMiles = (val: number) => val / 1609;

export const isInteger = (value: string) => {
  return /^\d+$/.test(value);
};
export const isNumeric = (value: string) => {
  return /[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)/.test(value);
};

export const roundToTwoDecimalPlaces = (num: number) =>
  Math.round((num + Number.EPSILON) * 100) / 100;
